/**
 * A line written for the OTHER person in the chat (`hidden_for`, BUG-614).
 *
 * "The other party declined" is true for the requester and false for the
 * member who declined, so the server hides it from the decliner - and both
 * clients showed it anyway: the answer to the decline returns it, and the
 * conversation-room socket event carries it to both people. The server's own
 * message list already filters it; every other way in asks this.
 */
export const isHiddenFor = (message, userId) =>
  Boolean(userId) && Array.isArray(message?.hidden_for) && message.hidden_for.includes(userId);
